
    export default {
        data() {
            return {
                services: [
                    {
                        title: "Review Infrastructure",
                        desc: "Before any chargers may be installed, the existing infrastructure must be reviewed to determine project scope.",
                        icon: "icofont-architecture"
                    },
                    {
                        title: "Feasibility Study",
                        desc: "Feasibility studies are conducted to determine the existing demand for electricity and evaluate future need.",
                        icon: "icofont-clip-board"
                    },
                    {
                        title: "Engineered Drawings",
                        desc: "We create blueprints that are suitable for submitting building permits to local municipalities for your projects.",
                        icon: "icofont-ruler-compass-alt"
                    },
                    {
                        title: "Engineering & Installation",
                        desc: "In addition to EV charger installation, we also offer a full suite of electrical engineering services.",
                        icon: "icofont-charging"
                    },
                    {
                        title: "Network Metering",
                        desc: "Provides additional income by taking the excess electricity gathered from solar and adding it back to the grid.",
                        icon: "icofont-energy-solar"
                    },
                    {
                        title: "Load Sharing",
                        desc: "With distributed load sharing, each EV charger connected to the system will receive the same amount of electricity.",
                        icon: "icofont-bars"
                    }
                ]
            }
        },
    };
